<template>
  <section>
    <fragment>
      <modal
        class="custom-modal"
        v-model="isOpen"
        :before-close="beforeClose"
        ref="modal"
        :footer="false"
        size="lg"
        id="confectionModalWrapper"
      >
        <template #header>
          <a
            role="button"
            href="#"
            class="custom-modal__close"
            type="button"
            @click.prevent="beforeClose"
          >
            <span class="mi mi-cross"></span>
          </a>
        </template>
        <confection-default-modal
          :file="fileUrl"
          :image="imageUrl"
          v-if="modalType === modalDefinedTypes.DEFAULT"
        />
        <etui-card-modal
          :file="fileUrl"
          :image="imageUrl"
          v-if="modalType === modalDefinedTypes.ETUI_CARD"
        />
        <envelope-card-modal
          :file="fileUrl"
          :image="imageUrl"
          v-if="modalType === modalDefinedTypes.ENVELOPE_CARD"
        />
        <etui-coupon-modal
          :file="fileUrl"
          :image="imageUrl"
          v-if="modalType === modalDefinedTypes.ETUI_COUPON"
        />

        <envelope-coupon-modal
          :image="imageUrl"
          v-if="modalType === modalDefinedTypes.ENVELOPE_COUPON"
        />
        <envelope-coupon-put-in-modal
          :image="imageUrl"
          v-if="modalType === modalDefinedTypes.ENVELOPE_COUPON_PUT_IN"
        />
        <n-d-e-envelope-card-personalisation-modal
          :file="fileUrl"
          :image="imageUrl"
          v-if="modalType === modalDefinedTypes.ENVELOPE_COUPON_PERSONALISATION"
        />

        <n-d-e-promo-packet-modal
          :image="imageUrl"
          v-if="modalType === modalDefinedTypes.NDE_PROMO_PACKET"
        />
        <n-d-e-etui-card-modal
          :image="imageUrl"
          v-if="modalType === modalDefinedTypes.NDE_ETUI_CARD"
        />
        <n-d-e-etui-card-christmas-modal
          :image="imageUrl"
          v-if="modalType === modalDefinedTypes.NDE_ETUI_CARD_CHRISTMAS"
        />
        <n-d-e-etui-card-put-in-modal
          :image="imageUrl"
          v-if="modalType === modalDefinedTypes.NDE_ETUI_CARD_PUT_IN"
        />
        <n-d-e-etui-card-personalisation-modal
          :file="fileUrl"
          :image="imageUrl"
          v-if="modalType === modalDefinedTypes.NDE_ETUI_CARD_PERSONALISATION"
        />
        <n-d-e-envelope-card-personalisation-modal
          :file="fileUrl"
          :image="imageUrl"
          v-if="modalType === modalDefinedTypes.NDE_ENVELOPE_CARD_PERSONALISATION"
        />
        <n-d-e-app-confection-modal
          :image="imageUrl"
          v-if="modalType === modalDefinedTypes.NDE_APP_CONFECTION"
        />

        <div class="custom-modal__controls">
          <fragment v-if="showAddToCart">
            <button
              type="button"
              class="btn btn-primary"
              @click="addConfectionItemToCart"
              :disabled="isItemAlreadyInCart"
            >
              {{ isItemAlreadyInCart ? "Dodano do zamówienia!" : "Dodaj do zamówienia" }}
            </button>
            <button type="button" class="btn btn-outline-primary" @click="beforeClose">
              Może innym razem...
            </button>
          </fragment>
          <fragment v-else>
            <button type="button" class="btn btn-outline-primary" @click="beforeClose">
              Zamknij
            </button>
            <a
              v-if="showDownloadFileButton"
              :href="fileUrl"
              target="_blank"
              class="btn btn-primary"
            >
              Pobierz szablon
            </a>
          </fragment>
        </div>
      </modal>
    </fragment>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import NDEEtuiCardModal from '@/components/Modals/NDEEtuiCardModal.vue';
import NDEEtuiCardChristmasModal from '@/components/Modals/NDEEtuiCardChristmasModal.vue';
import NDEEtuiCardPutInModal from '@/components/Modals/NDEEtuiCardPutInModal.vue';
import NDEEtuiCardPersonalisationModal from '@/components/Modals/NDEEtuiCardPersonalisationModal.vue';
import NDEEnvelopeCardPersonalisationModal from '@/components/Modals/NDEEnvelopeCardPersonalisationModal.vue';
import NDEPromoPacketModal from '@/components/Modals/NDEPromoPacketModal.vue';
import NDEAppConfectionModal from '@/components/Modals/NDEAppConfectionModal.vue';
import EtuiCardModal from './etuiCardModal.vue';
import EnvelopeCardModal from './envelopeCardModal.vue';
import EtuiCouponModal from './etuiCouponModal.vue';
import EnvelopeCouponModal from './envelopeCouponModal.vue';
import EnvelopeCouponPutInModal from './envelopeCouponPutInModal.vue';
import confectionDefaultModal from './confectionDefaultModal.vue';
import { modalType as modalDefinedTypes } from './modalType';
import { resolveConfectionModalImageName } from '@/utils/confection/modals';

export default {
  name: 'ConfectionModal',
  components: {
    NDEEtuiCardModal,
    NDEEtuiCardChristmasModal,
    NDEEtuiCardPutInModal,
    NDEEtuiCardPersonalisationModal,
    NDEEnvelopeCardPersonalisationModal,
    NDEPromoPacketModal,
    NDEAppConfectionModal,
    confectionDefaultModal,
    EnvelopeCouponModal,
    EtuiCouponModal,
    EnvelopeCardModal,
    EtuiCardModal,
    EnvelopeCouponPutInModal,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    modalType: {
      type: String,
      required: true,
    },
    fileName: {
      type: String,
      default: 'Zalacznik_do_konfekcji_kart–wzor.xlsx',
    },
    confectionItemSlug: {
      type: String,
    },
    isExclusiveConfectionItem: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    addConfectionItemToCart() {
      if (this.isExclusiveConfectionItem) {
        this.$store.dispatch('confection/setSelectedExclusiveItem', this.confectionItemSlug);
      } else {
        this.$store.dispatch('confection/handleConfectionItemSelection', {
          selectedItem: this.confectionItemSlug,
          isSelected: true,
        });
      }
      this.beforeClose();
    },
    beforeClose() {
      this.$emit('handleModalOpen', null);
    },
    createImageUrl(imageName) {
      return `${process.env.VUE_APP_BASE_URL}/media/${imageName}`;
    },
  },
  computed: {
    ...mapState({
      selectedExclusiveItem: state => state.confection.selectedExclusiveItem,
      selectedConfectionItems: state => state.confection.selectedConfectionItems,
      currentStep: state => state.steps.currentStep,
      stepType: state => state.steps.stepType,
    }),
    isItemAlreadyInCart() {
      if (this.isExclusiveConfectionItem) {
        return this.selectedExclusiveItem === this.confectionItemSlug;
      }
      return !!this.selectedConfectionItems[this.confectionItemSlug];
    },
    showAddToCart() {
      return this.currentStep === this.stepType.START && !!this.confectionItemSlug;
    },
    modalDefinedTypes() {
      return modalDefinedTypes;
    },
    showDownloadFileButton() {
      return [
        modalDefinedTypes.DEFAULT,
        modalDefinedTypes.ENVELOPE_CARD,
        modalDefinedTypes.ETUI_CARD,
        modalDefinedTypes.ETUI_COUPON,
      ].includes(this.modalType);
    },
    parentProductSlug() {
      const products = this.$store.getters.deliveriesProducts(0);
      return products[0] ? products[0].slug : '';
    },
    imageUrl() {
      const parentId = this.$store.getters.allProducts[0].idproducts;
      const imageName = resolveConfectionModalImageName(parentId, this.modalType);
      return this.createImageUrl(imageName);
    },
    fileUrl() {
      return `https://cdn.pluxee.pl/panel-klienta/example_files/${this.fileName}`;
    },
  },
};
</script>

<style lang="scss"></style>
